import { Action } from '@ngrx/store';

export enum ScreenActionTypes {
  XSLayout   = '@digitaix/core/layout/XS_LAYOUT',
  SMLayout   = '@digitaix/core/layout/SM_LAYOUT',
  MDLayout   = '@digitaix/core/layout/MD_LAYOUT',
  LGLayout   = '@digitaix/core/layout/LG_LAYOUT',
  XLLayout   = '@digitaix/core/layout/XL_LAYOUT',
  LTSMLayout = '@digitaix/core/layout/LTSM_LAYOUT',
  LTMDLayout = '@digitaix/core/layout/LTMD_LAYOUT',
  LTLGLayout = '@digitaix/core/layout/LTLG_LAYOUT',
  LTXLLayout = '@digitaix/core/layout/LTXL_LAYOUT',
  GTSMLayout = '@digitaix/core/layout/GTSM_LAYOUT',
  GTMDLayout = '@digitaix/core/layout/GTMD_LAYOUT',
  GTLGLayout = '@digitaix/core/layout/GTLG_LAYOUT',
  GTXSLayout = '@digitaix/core/layout/GTXS_LAYOUT',
}

export const BlackListScreenActionTypes = [
  ScreenActionTypes.XSLayout,
  ScreenActionTypes.SMLayout,
  ScreenActionTypes.MDLayout,
  ScreenActionTypes.LGLayout,
  ScreenActionTypes.XLLayout,
  ScreenActionTypes.LTSMLayout,
  ScreenActionTypes.LTMDLayout,
  ScreenActionTypes.LTLGLayout,
  ScreenActionTypes.LTXLLayout,
  ScreenActionTypes.GTSMLayout,
  ScreenActionTypes.GTMDLayout,
  ScreenActionTypes.GTLGLayout,
  ScreenActionTypes.GTXSLayout
];

export class XSLayout implements Action {
  public readonly type = ScreenActionTypes.XSLayout;
}

export class SMLayout implements Action {
  public readonly type = ScreenActionTypes.SMLayout;
}

export class MDLayout implements Action {
  public readonly type = ScreenActionTypes.MDLayout;
}

export class LGLayout implements Action {
  public readonly type = ScreenActionTypes.LGLayout;
}

export class XLLayout implements Action {
  public readonly type = ScreenActionTypes.XLLayout;
}

export class LTSMLayout implements Action {
  public readonly type = ScreenActionTypes.LTSMLayout;
}

export class LTMDLayout implements Action {
  public readonly type = ScreenActionTypes.LTMDLayout;
}

export class LTLGLayout implements Action {
  public readonly type = ScreenActionTypes.LTLGLayout;
}

export class LTXLLayout implements Action {
  public readonly type = ScreenActionTypes.LTXLLayout;
}

export class GTSMLayout implements Action {
  public readonly type = ScreenActionTypes.GTSMLayout;
}

export class GTMDLayout implements Action {
  public readonly type = ScreenActionTypes.GTMDLayout;
}

export class GTLGLayout implements Action {
  public readonly type = ScreenActionTypes.GTLGLayout;
}

export class GTXSLayout implements Action {
  public readonly type = ScreenActionTypes.GTXSLayout;
}

export type ScreenActions =
  XSLayout
  | SMLayout
  | MDLayout
  | LGLayout
  | XLLayout
  | LTLGLayout
  | LTSMLayout
  | LTMDLayout
  | LTXLLayout
  | GTXSLayout
  | GTSMLayout
  | GTMDLayout
  | GTLGLayout;
